import Argent from "../../../components/icons/Wallets/Argent"
import ArgentX from "../../../components/icons/Wallets/ArgentX"
import Braavos from "../../../components/icons/Wallets/Braavos"
import Keplr from "../../../components/icons/Wallets/Keplr"

const KnownStarknetConnectors = [
    {
        id: 'argent x',
        icon: ArgentX
    },
    {
        id: 'argent mobile',
        icon: Argent
    },
    {
        id: 'braavos',
        icon: Braavos
    },
    {
        id: 'keplr',
        icon: Keplr
    }
]

export default KnownStarknetConnectors